<div class="card">
  <div class="card-body" style="padding:10px">
    <div class="row w-100">
      <div class="col-md-12 pt-0">
        <h5 class="border-bottom pb-1 mb-1">{{'componentPages.meetingmodule' | translate}}</h5>
      </div>
      <div class="col-lg-12">
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>
      <div class="col-12 d-flex justify-content-start mt-2">
        <div class="row w-100">
          <div class="col-12 col-xl col-md-6">
            <div class="form-group mb-0">
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="editweightfilter['ay']" class="form-control custom-selectbox w-100">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6">
            <div class="form-group mb-0">
              <label>{{ 'dataSubs.selectmode' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedMode" class="form-control custom-selectbox w-100"
                (change)="showdropdown(selectedMode)">
                <option value="undefined">{{ 'dataSubs.selectmode' | translate }}</option>
                <option *ngFor="let mode of modeList" [value]="mode.key">{{ 'dataSubs.' + mode.value | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6"
            *ngIf="showDrop == 'statewise' || showDrop == 'reportsummary' || showDrop=='consolidatedreport'">
            <div class="form-group mb-0 px-3">
              <label>{{'header.state' | translate}}<span class="required-field">*</span></label>
              <select disabled="" class="form-control custom-selectbox selectdis">
                <option *ngFor="let state of statelists" value="{{state['uuid']}}">
                  {{'tabledataforstates.' +state['name'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6"
            *ngIf="showDrop == 'monthwise' || showDrop == 'statewise' || showDrop == 'consolidatedreport'">
            <div class="form-group px-3 mb-0">
              <label>{{'dataSubs.month' | translate}}<span class="required-field">*</span></label>
              <select [(ngModel)]="editweightfilter['month']" class="form-control custom-selectbox">
                <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                <option *ngFor="let month of monthsList" [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-auto d-flex align-items-end mt-4">
            <button class="btn btn-info pointer" (click)="fetchtableData()" *ngIf="showDrop == 'monthwise' || showDrop == 'consolidatedreport' || showDrop == 'abstractreport'"
              type="submit">{{'dataSubs.VIEW' | translate}}</button>
            <button *ngIf="showDrop == 'reportsummary'" class="btn btn-info pointer" (click)="fetchtableData()"
              type="submit">{{'dataSubs.download' | translate}}</button>
          </div>
          <div class="col-auto d-flex align-items-end mt-4" *ngIf="(showDrop == 'abstractreport' && abstractRepData) || showDrop == 'monthwise'">
            <button class="btn btn-info pointer" (click)="printReport(showDrop)" type="submit">{{ 'listofdgc.print' | translate }}</button>
          </div>

          <div class="col-12">
            <div class="form-group mt-3">
              <div class="table-responsive table-bordered table-responsive-lg table-responsive-md table-responsive-sm"
                *ngIf="showAttendence && selectedMode=='monthwise' ">
                <table class="table text-center table-sm mt-1">
                  <thead>
                    <tr>
                      <th style="font-size: small;">{{'dataSubs.Total DGCs' | translate}}</th>
                      <th style="font-size: small;">{{'dataSubs.DGCs- Submitted Meetings Reports' | translate}}</th>
                      <th style="font-size: small;">{{'dataSubs.DGCs- Not Submitted Meetings Reports' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let attendant of attendenceReport">
                      <td style="text-align: center">{{attendant['to']}}</td>
                      <td style="text-align: center">{{attendant['att']}}</td>
                      <td style="cursor: pointer;text-align: center;color:#0080ff"  (click)="openmeetingWindow()">{{attendant['non']}}
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
        <!-- <div class="form-group px-3">
          <label>Print Meeting Report Summary</label><br>
          <select>
            <option [disabled]="true">select state</option>
            <option  *ngFor="let state of statelists">
              <button (click)="downloadMRS(state['name'])">{{state['name']}}</button>
            </option>
          </select>
         </div> -->
      </div>

    </div>

    <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm"
      *ngIf="showtabledata && showDrop !='consolidatedreport' && showDrop !='abstractreport'">
      <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
        [style.height]="availabledistdata.length > 0 ? '500px' : '185px'">
        <table class="table text-center table-sm mt-1">
          <thead class="thead-light">
            <tr style="position:sticky; top: -0.5px;">
              <th>{{'submitdata.slno' | translate}}</th>
              <th (click)="sortRows('state')">{{'trigManage.statename' | translate}}</th>
              <th (click)="sortRows('name')">{{'trigManage.DGCname' | translate}}</th>
              <th>{{'trigManage.view' | translate}}</th>
              <th>{{'trigManage.filedownload' | translate}}</th>
              <th>{{ 'submitdata.dateofmeeting' | translate }}  <i class="fas fa-sort pointer" (click)="sortRows('dateofMeeting')"></i></th>
              <th>{{'dataSubs.Date of Submission' | translate}}  <i class="fas fa-sort pointer" (click)="sortRows('date')"></i></th>
            </tr>
          </thead>
          <tbody class="text-white">
            <tr *ngFor="let table of availabledistdata ; let i = index">
              <td style="text-align: center">{{i+1}}</td>
              <td style="text-align: center">{{'tabledataforstates.' +table['state'] | translate}}</td>
              <td style="text-align: center">{{'districtsdata.' +table['name'] | translate}}</td>
              <td><a class="pointer" title="View Data" (click)="infoClick(table,table['id'],table['name'])"><i
                    class="fa fa-eye"></i></a></td>
              <td title="Download Data"><a class="pointer"><i class="fa fa-download"
                    (click)="downloadFile(table['id'],table['name'])"></i></a></td>
              <td style="text-align: center">{{table['dateofMeeting'] ? formatdate(table['dateofMeeting']) : '-'}}</td>
              <td style="text-align: center">{{this.getDateandTimeString(table['date'],"DD-MM-YYYY")}}</td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
      <div class="row" *ngIf="availabledistdata.length == 0">
        <div class="col-12 nodata">
          {{'infotab.nodata' | translate}}
        </div>
      </div>
    </div>
    <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm"
      *ngIf="showtabledata && showDrop =='consolidatedreport'">
      <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
        [style.height]="fetchReport && fetchReport.length > 0 ? '500px' : '185px'">
        <table class="table text-center table-sm mt-1">
          <thead class="thead-light">
            <tr style="position:sticky; top: -0.5px;">
              <th>{{'submitdata.slno' | translate}}</th>
              <th>{{'trigManage.statename' | translate}}</th>
              <th>{{ 'dataSubs.Date of Submission' | translate }}</th>
              <th>{{'trigManage.filedownload' | translate}}</th>
            </tr>
          </thead>
          <tbody class="text-white">
            <tr *ngFor="let table of fetchReport ; let i = index">
              <td style="text-align: center">{{i+1}}</td>
              <td style="text-align: center">{{'tabledataforstates.'+ table['stateName'] | translate}}</td>
              <td style="text-align: center">{{table['date']}}</td>
              <td class="text-center"><a><i class="fa fa-download" (click)="downloadConsolidatedReport(table['uuid'])"
                    aria-hidden="true"></i></a></td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
      <div class="row" *ngIf="fetchReport && fetchReport.length == 0">
        <div class="col-12 nodata">
          {{'infotab.nodata' | translate}}
        </div>
      </div>
    </div>
    <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm"
      *ngIf="showtabledata && showDrop =='abstractreport'" id="content">
      <h5 style="text-align: center;">{{ 'dataSubs.DGCs Minutes of Meeting Status Report from April' | translate }} {{abstractYear[0]}} {{ 'dataSubs.onwards' | translate }}</h5>
      <table class="table text-center table-sm mt-1">
        <thead class="thead-light">
          <tr style="position:sticky; top: -0.5px;">
            <th>{{ 'monthmaps.April' | translate }} {{abstractYear[0]}} {{ 'dataSubs.to' | translate }} {{ 'monthmaps.March' | translate }} {{abstractYear[1]}}</th>
            <!-- <th>Reports Uploaded</th> -->
            <th>{{ 'tabledataforstates.' + userdetails['loggedUserData']['userProfile']['locationName'] |  translate }} </th> <!-- ({{dgcCount}}) -->
          </tr>
        </thead>
        <tbody class="text-white">
          <tr *ngFor="let rep of abstractRepData;">
            <td>{{ rep['month']}}</td>
            <!-- <td>{{rep['reportsuploaded']}}</td> -->
            <td>{{rep['statereports']}}</td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="row" *ngIf = "abstractRepData.length == 0">
        <div class="col-12 nodata">
          {{'infotab.nodata' | translate}}
        </div>
      </div> -->
    </div>
  </div>
</div>
<ng-template #meetingModal>
  <!-- <div class="modal-content  dark_bg" style="border: 1px solid #ccc ;"> -->
  <!-- <spinner [id]="'approveinfo'" [show]='activeSpinner'></spinner> -->
  <div class="modal-header " style=" margin-bottom: 0px !important;">
    <h5 class="modal-title"><i class="fa fa-eye" aria-hidden="true"></i> {{ 'dataSubs.DGCs- not submitted meeting reports' | translate }} -
      {{currentMonthVar}} {{selectedYear}}</h5>
    <button type="button" class="close pointer text-black" (click)="closeModal()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="padding:0px">
    <div class="row">
      <div class="col-md-12">
        <div id="accordion">
          <div class="card">
            <div id="approvalhistory">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm table-dark m-0 adminmeeting-table" style="width: 78.67rem;">
                    <thead>
                      <tr>
                        <th scope="col">{{ 'dataSubs.SNo' | translate }}</th>
                        <th scope="col">{{'header.state' | translate }}</th>
                        <th scope="col">{{'dataSubs.DGCs which have not submitted meeting reports' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let state of clickableData | keyvalue ;let i = index">
                        <td *ngIf="state.key!='attendant' && state.key != 'pendingReport'">{{i+1}}</td>
                        <!-- <td *ngIf="state.key!='attendant' && state.key == 'pendingReport'">&nbsp;</td> -->
                        <td *ngIf="state.key!='attendant' && state.key != 'pendingReport'" style="width:190px;">
                          {{'tabledataforstates.' + state.key | translate}}({{state.value.length}})</td>
                        <!-- <td *ngIf="state.key!='attendant' && state.key == 'pendingReport'" style="width:190px;"> TOTAL</td> -->
                        <b>
                          <td *ngIf="state.key!='attendant' && state.key != 'pendingReport'">
                            <ng-container *ngFor="let st of state.value; let j = index">
                              {{'districtsdata.' + st | translate}} <span *ngIf="state.value.length > j+1">,</span>
                            </ng-container>
                            <!-- {{(state.value && state.value.length)?state.value.join(" , "):'-'}} -->
                          </td>
                        </b>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table table-sm table-dark m-0 adminmeeting-table">
                    <tbody>
                      <tr>
                        <td>
                          <h5><b>{{'dataSubs.Total Meeting Reports not submitted in' | translate}} {{'monthmaps.' + currentMonthVar | translate}} {{selectedYear}}</b></h5>
                        </td>
                        <td>
                          <h5><b>{{attendenceReport[0]['non']}}</b></h5>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5><b>{{'dataSubs.Overall Meeting Reports not submitted from April' | translate}} {{currentYearVar}} till
                            {{'monthmaps.' + currentMonthVar | translate}} {{selectedYear}}</b></h5>
                        </td>
                        <td>
                          <h5><b> {{clickableData['pendingReport']}}</b></h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</ng-template>
